import React, { useEffect, useState } from 'react';
import { SbBlokData } from '@storyblok/react';

import { Button, Logo } from '@savebetter/components';

import IntroductionDescription from './IntroductionDescription';
import IntroductionList from './IntroductionList';
import { LinkProps } from './Link';
import { MediaProps } from './Media';
import PageTitle from './PageTitle';

interface ListItem extends SbBlokData {
  text: string;
}

interface HeroBannerProps {
  headerBackground: MediaProps[];
  title: string;
  isTextWhite: boolean;
  logo: MediaProps[];
  introductionList: ListItem[];
  introductionLink: LinkProps[];
  isLinkSecondaryColor: boolean;
  introductionDescription?: string;
}

type HeroBannerContentProps = Omit<HeroBannerProps, 'headerBackground'>;

const HeroBannerContent: React.FC<HeroBannerContentProps> = ({
  title,
  isTextWhite,
  logo,
  introductionList,
  introductionLink,
  isLinkSecondaryColor,
  introductionDescription
}) => (
  <div className="flex flex-col hero-banner-content">
    {logo.length > 0 && (
      <Logo
        alt={logo[0].alt}
        src={logo[0].img}
        className="mb-default md:mb-6 w-max max-w-44"
        size={{ sm: 'sm', md: 'sm', lg: 'md' }}
      />
    )}
    <PageTitle isTextWhite={isTextWhite} logoLen={logo.length > 0} title={title} />
    {introductionList.length > 0 && <IntroductionList introductionList={introductionList} isTextWhite={isTextWhite} />}
    {introductionDescription && (
      <IntroductionDescription isTextWhite={isTextWhite} textDescription={introductionDescription} />
    )}
    {introductionLink.length > 0 && (
      <>
        <Button
          kind="primary"
          className="mt-4 hidden md:flex inline-flex self-start"
          isSecondaryColor={isLinkSecondaryColor}
          href={introductionLink[0].url}
          target={introductionLink[0].target}
        >
          {introductionLink[0].text}
        </Button>
        <Button
          kind="primary"
          className="mt-4 md:hidden flex inline-flex self-center"
          isSecondaryColor={false}
          href={introductionLink[0].url}
          target={introductionLink[0].target}
        >
          {introductionLink[0].text}
        </Button>
      </>
    )}
  </div>
);

export const HeroBanner: React.FC<HeroBannerProps> = ({ headerBackground, ...restProps }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener('resize', handleResize);
  });
  return (
    <>
      {windowWidth <= 1024 ? (
        <section className="sb-section hero-banner-mobile p-4 pb-6 bg-gradient-to-r from-[#063e69] to-[#2175b0]">
          <HeroBannerContent {...restProps} />
        </section>
      ) : (
        <section className="hero-banner-desktop justify-items-start items-start">
          {headerBackground.length > 0 && (
            <div
              className="w-1/1 hero-banner bg-cover"
              style={{
                backgroundImage: `url("${headerBackground[0].img}")`,
                backgroundPosition: 'top right 36%'
              }}
            >
              <div className="sb-section-content col-start-1 row-start-1 pb-18 pt-18 m-auto">
                <HeroBannerContent {...restProps} />
              </div>
            </div>
          )}
        </section>
      )}
    </>
  );
};
